import { setIsHomepageLogged } from "src/hooks/useHomepageIsLogged";
import axiosServices from "../initNetwork";

let isRefreshing = false;
let refreshSubscribers: ((success: boolean) => void)[] = [];
function onRefreshed(success: boolean) {
  for (const callback of refreshSubscribers) {
    callback(success);
  }
  refreshSubscribers = [];
}

export default async function refreshInterceptor(error: any) {
  const originalRequest = error.config;

  if (
    error.response.status === 401 &&
    !originalRequest._retry &&
    originalRequest.url !== "/auth/refresh"
  ) {
    if (originalRequest.url === "/auth/logout") {
      setIsHomepageLogged(false);
      window.location.href = `/logowanie?redirect=${encodeURIComponent(
        location.pathname + location.search,
      )}`;
      return Promise.reject(error);
    }

    originalRequest._retry = true;

    if (!isRefreshing) {
      isRefreshing = true;
      try {
        await axiosServices.post("/auth/refresh");
        isRefreshing = false;
        onRefreshed(true);
        return axiosServices(originalRequest);
      } catch (refreshError) {
        isRefreshing = false;
        onRefreshed(false);
        setIsHomepageLogged(false);
        window.location.href = `/logowanie?redirect=${encodeURIComponent(
          location.pathname + location.search,
        )}`;
        // to avoid showing error boundary
        return axiosServices(originalRequest);
      }
    }

    return new Promise((resolve, reject) => {
      refreshSubscribers.push((success: boolean) => {
        if (success) {
          axiosServices(originalRequest).then(resolve).catch(reject);
        } else {
          reject(error);
        }
      });
    });
  }
  return Promise.reject(error);
}
